import {
	createMenuStore,
	useMenu,
} from '@netx/core-app-next/store/menuItemsBase';
import {
	userActionChangePassword,
	userActionLogout,
	userActionSettings,
} from '@netx/core-user-next/actions';
import {userActionHelp} from '@netx/core-user-next/actions/user-help';
import {userActionLoginPublicAccess} from '@netx/core-user-next/actions/user-login-public-access';
import {useLocales} from '@netx/core-next/locales/utils/useLocales';

export const useUserMenuStore = createMenuStore();

useUserMenuStore
	.getState()
	.addMenuItems(
		[
			userActionLogout({group: 1000}),
			userActionLoginPublicAccess({group: 1000}),
		],
		{
			section: 'user',
		},
	);

useUserMenuStore.getState().addMenuItems([userActionHelp({group: 4})], {
	section: 'help',
});

useUserMenuStore
	.getState()
	.addMenuItems([userActionSettings({group: 3, order: 0})], {
		section: 'settings',
	});

useUserMenuStore
	.getState()
	.addMenuItems([userActionChangePassword({group: 3, order: 1})], {
		section: 'password',
	});

export const useUserMenu = () => {
	return useMenu({store: useUserMenuStore});
};
